module.exports = __webpack_public_path__ + "static/SP_intake_form_4.0-3b2fb0ee6c8db1789252e629833a6bc7.pdf";